module.exports = __webpack_public_path__ + "static/media/arrow-up.17e1e126.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/arrow-up.svg
// module id = 46
// module chunks = 0